var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',_vm._b({},'Card',_vm.$attrs,false),[_c('v-row',{staticClass:"px-4",staticStyle:{"height":"52px"},attrs:{"align":"center","no-gutters":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }